import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { Card, Form, Button } from "react-bootstrap";
import { FaStethoscope, FaSave } from "react-icons/fa";
import { MdCategory } from "react-icons/md";
//Context import
import AuthContext from "../../../components/shared/Context";

const PatientTreatmentCenterUpdateModal = ({ currentRecord }) => {
  let navigate = useNavigate();
  const { loggedInUserDetails } = useContext(AuthContext);
  const [tcenterOptions, setTcenterOptions] = useState([]);
  const [confirmTransfer, setConfirmTransfer] = useState(false);
  const [formData, setFormData] = useState({
    tc_detail: currentRecord?.tc_detail?._id,
    treatment_center: currentRecord?.tc_detail?._id,
    notes: null,
  });
  const [error, setError] = useState("");

  // Add custom styles for react-select
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: "white",
      borderColor: state.isFocused ? "#2684FF" : "#e2e8f0",
      boxShadow: state.isFocused ? "0 0 0 1px #2684FF" : null,
      borderRadius: "0.375rem",
      minHeight: "42px",
      "&:hover": {
        borderColor: state.isFocused ? "#2684FF" : "#cbd5e0",
      },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#2684FF"
        : state.isFocused
        ? "#deebff"
        : "white",
      color: state.isSelected ? "white" : "black",
      padding: "8px 12px",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#a0aec0",
    }),
  };

  useEffect(() => {
    const getTCDataFromServer = () => {
      let userToken = localStorage.getItem("token");
      let urlLink = `${process.env.REACT_APP_API_URL}/tc/state/${loggedInUserDetails.state}`;
      const config = {
        method: "GET",
        url: urlLink,
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };

      axios(config)
        .then(function (response) {
          //console.log(JSON.stringify(response.data.treatment_center));
          const oldData = response.data.treatment_center;
          const updatedData = oldData.map((data) => {
            return {
              value: data._id,
              label: data.tcenters.name_tc,
              hdcc_no: data.tcenters.hdcc_no,
              state: data.tcenters.state,
              district: data.tcenters.district,
              tcid: data?.tcenters?.treatment_center_id,
              tc_type: data.tcenters?.tc_type,
            };
          });
          //console.log(updatedData);
          setTcenterOptions(updatedData);
        })
        .catch(function (error) {
          //console.log(error.message);
        });
    };
    getTCDataFromServer();
  }, []);

  const handleSubmit = () => {
    // Add validation for notes
    if (!formData.notes || formData.notes.trim() === "") {
      setError("Please enter notes for the transfer");
      return;
    }

    let userToken = localStorage.getItem("token");
    let urlLink = `${process.env.REACT_APP_API_URL}/patient/update/tc-transfer/${currentRecord?._id}`;

    const config = {
      method: "POST",
      url: urlLink,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      data: { ...formData },
    };

    axios(config)
      .then((res) => {
        navigate("/patients");
      })
      .catch((err) => console.log("error", err));
    console.log("Submitting form data:", formData);
  };

  return (
    <Card className="p-4">
      <Form>
        <Form.Group className="mb-3">
          <div className="d-flex align-items-center mb-2">
            <MdCategory className="me-2 text-secondary" size={20} />
            <Form.Label className="fw-bold">Treatment Center(s)</Form.Label>
          </div>
          <Select
            name="tc_detail"
            onChange={(selected) => {
              setFormData({
                ...formData,
                tc_detail: selected.value,
                treatment_center: selected.value,
              });
            }}
            options={tcenterOptions}
            styles={customStyles}
            value={
              formData.tc_detail
                ? tcenterOptions.find((cat) => cat.value === formData.tc_detail)
                : null
            }
            placeholder="Select category..."
            classNamePrefix="react-select"
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <div className="d-flex align-items-center mb-2">
            <FaStethoscope className="me-2 text-secondary" size={20} />
            <Form.Label className="fw-bold">Notes *</Form.Label>
          </div>
          <Form.Control
            as="textarea"
            rows={3}
            name="notes"
            value={formData.notes || ""}
            onChange={(e) => {
              setError("");
              setFormData({ ...formData, notes: e.target.value });
            }}
            placeholder="Enter notes for transfer (required)..."
            isInvalid={!!error}
          />
          <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Check
            type="checkbox"
            id="transfer-confirmation"
            label="Are you sure to Transfer patient as after that patient will not be visible in your list and you will not be able to manage this patient."
            checked={confirmTransfer}
            onChange={(e) => setConfirmTransfer(e.target.checked)}
            className="text-danger"
          />
        </Form.Group>

        <div className="d-flex justify-content-end">
          <Button
            variant="primary"
            onClick={handleSubmit}
            className="d-flex align-items-center"
            disabled={!confirmTransfer}
          >
            <FaSave className="me-2" />
            Save Changes
          </Button>
        </div>
      </Form>
    </Card>
  );
};

export default PatientTreatmentCenterUpdateModal;
